import { Flex, Typography } from '@banhala/ui-kit';
import { EmptyProductIcon } from './EmptyProductIcon';

export const MySizeEmptyState = () => {
  return (
    <Flex
      borderRadius={8}
      borderColor="border_tertiary"
      borderWidth={1}
      padding={{ horizontal: 20, vertical: 20 }}
      gap={16}
    >
      <Flex padding={{ vertical: 16 }} gap={24} alignItems="center">
        <Flex gap={8} alignItems="center">
          <EmptyProductIcon />
          <Flex gap={8} alignItems="center">
            <Typography type="subtitle1" color="content_secondary">
              등록된 사이즈가 없어요
            </Typography>
            <Typography
              type="body2-relaxed"
              color="content_tertiary"
              textAlign="center"
            >
              {'내 사이즈를 저장하면\n상품 상세에서 사이즈를 비교할 수 있어요'}
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
